import parse from "html-react-parser";

import { useMainContext } from "../context";
import { useLanguageContext } from "../context/languageContext";
import { QuestionComponentProps } from "../types/components";
import { FormCheckboxValue } from "../types/context";

export const AgreementsQuestion = ({ question }: QuestionComponentProps) => {
  const { form, handleCheckboxInput } = useMainContext();
  const { language, setLanguage } = useLanguageContext();

  return (
    <div className="step" data-step="step-4">
      <h2 className="title2">{question.questionName}</h2>
      <div className="step4">
        <div className="checkbox__container">
          <div className="checkbox-declaration">
            {parse(question.declaration)}
          </div>
          {question.answers.map((answer) => (
            <label key={answer.answerId} className="checkbox__content">
              <div className="checkbox__input">
                <input
                  id={answer.answerId}
                  type="checkbox"
                  value={answer.answerId}
                  onChange={(e) =>
                    handleCheckboxInput(question, e.target.value, answer)
                  }
                  checked={(
                    form[question.questionId].value as FormCheckboxValue
                  ).some((element) => element.value === answer.answerId)}
                />
              </div>
              <div className="checkbox-input-label">
                {parse(answer.answerName)}
              </div>
            </label>
          ))}
        </div>
      </div>
      <p className="required__field">
        {language === "PL" ? "*Pole wymagane" : "*Required field"}
      </p>
    </div>
  );
};
